module.exports = __webpack_public_path__ + "static/img/tree1.f82f9a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bench/tree1.png
// module id = 3tM2
// module chunks = 1